/* IRIS horizontal product carousel.
   Scrolls the track left/right via the arrows and keeps the arrow enabled
   states in sync with scroll position: at the far left the prev arrow is
   disabled, at the far right the next arrow is disabled, in between both are
   enabled. Also hides the arrows entirely when the row doesn't overflow. */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-iris-track]');
    var prev = root.querySelector('[data-iris-prev]');
    var next = root.querySelector('[data-iris-next]');
    if (!track) return;

    function stepAmount() {
      var item = track.querySelector('.iris-edit__item');
      var gap = 24;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var x = track.scrollLeft;
      var overflows = track.scrollWidth > track.clientWidth + 2;
      root.classList.toggle('is-scrollable', overflows);
      if (prev) prev.disabled = !overflows || x <= 0;
      if (next) next.disabled = !overflows || x >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -stepAmount() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: stepAmount() * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* Fonts/images can shift widths after load. */
    window.addEventListener('load', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-iris-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
